// extracted by mini-css-extract-plugin
export default {"item":"GDT7yc","icon":"tNhTtu","content":"meuxGy"};